// Analytics utility functions
export const initializeAnalytics = () => {
  const consent = localStorage.getItem("cookieConsent");

  if (consent === "accepted" && window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
    });
    // Only initialize if consent is given
    window.gtag("config", "G-DLKZMPN9E3", {
      anonymize_ip: true,
    });
  }
};

export const trackPageView = (path) => {
  const consent = localStorage.getItem("cookieConsent");

  if (consent === "accepted" && window.gtag) {
    window.gtag("config", "G-DLKZMPN9E3", {
      page_path: path,
      anonymize_ip: true,
    });
  }
};

export const trackEvent = (action, category, label, value) => {
  const consent = localStorage.getItem("cookieConsent");

  if (consent === "accepted" && window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
